import { LocalizationInitializerService } from './localization-initializer.service';

export function localizationInitializerFactory(localizationInitializerService: LocalizationInitializerService): () => Promise<void> {
  return () => localizationInitializerService.initializeLocalizationLanguages();
}
